import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SellerListingChatPageComponent } from './components/seller-listing-chat-page/seller-listing-chat-page.component';
import { ListingChatsPageComponent } from './components/listing-chats/listing-chats-page.component';
import { AllChatsPageComponent } from './components/all-chats-page/all-chats-page.component';

const routes: Routes = [

    {
      path: '',
      component: AllChatsPageComponent
    },
    {
      path: 'listings/:itemId',
      component: ListingChatsPageComponent
    },
    {
      path: 'listings/:itemId/chats/:chatId',
      component: SellerListingChatPageComponent
    }
]

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ListingChatsRoutingModule { }
